<h1 mat-dialog-title>
  {{ model ? 'Editar' : 'Agregar' }}
</h1>

<form [formGroup]="form" (submit)="model ? update(form.value) : create(form.value)" appPermissionControl="P097F0001">
  <div mat-dialog-content>
    <mat-grid-list [cols]="breakpoint" rowHeight="90px" (window:resize)="onResize($event)">
      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Formularios</mat-label>
            <mat-select formControlName="formId" appPermissionControl="P097K0001">
              <mat-option [value]="food.formId" *ngFor="let food of jsonModules">{{ food.formName }} </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Rol</mat-label>
            <mat-select formControlName="rolId" appPermissionControl="P097K0002">
              <mat-option [value]="item.id" *ngFor="let item of roles">{{ item.description }} </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Habilitado</mat-label>
            <mat-select formControlName="enable" appPermissionControl="P097K0003">
              <mat-option [value]="true">Habilitado </mat-option>
              <mat-option [value]="true">Inhabilitado </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>
      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Agregar</mat-label>
            <mat-select formControlName="create" appPermissionControl="P097K0004">
              <mat-option [value]="true">Habilitado </mat-option>
              <mat-option [value]="true">Inhabilitado </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>
      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Editar</mat-label>
            <mat-select formControlName="update" appPermissionControl="P097K0005">
              <mat-option [value]="true">Habilitado </mat-option>
              <mat-option [value]="false">Inhabilitado </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>
      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Leer</mat-label>
            <mat-select formControlName="read" appPermissionControl="P097K0006">
              <mat-option [value]="true">Habilitado </mat-option>
              <mat-option [value]="false">Inhabilitado </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>
      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Eliminar</mat-label>
            <mat-select formControlName="delete" appPermissionControl="P097K0007">
              <mat-option [value]="true">Habilitado </mat-option>
              <mat-option [value]="false">Inhabilitado </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>
    </mat-grid-list>
  </div>

  <div mat-dialog-actions>
    <ng-container *ngIf="!loading"
      ><button class="botonFm btn-cancel" type="button" mat-raised-button (click)="close()" appPermissionControl="P097B0001">Cancelar</button>
      <button class="botonFm" mat-raised-button color="accent" appPermissionControl="P097B0002">
        {{ model ? 'Actualizar' : 'Guardar' }}
      </button>
    </ng-container>
    <button *ngIf="loading" class="botonGrandeFm" mat-raised-button color="accent" type="button" appPermissionControl="P097B0003">
      Cargando
      <mat-progress-bar mode="buffer"></mat-progress-bar>
    </button>
  </div>
</form>
